// AUTO-GENERATED by :tooling:ts-codegen — DO NOT EDIT.
// Regenerate with `./gradlew :tooling:ts-codegen:generateTsApi`.
// Source of truth: shared/src/commonMain (the Kotlin API contract).

import type { AckIncidentRequest, AddCommentRequest, AddJobRequest, AddLinkRequest, AdminOverviewResponse, AdoptBaselineRequest, AdoptBaselineResponse, AgentVersionsResponse, ApplyRequest, AskClaudeRequest, AssignIncidentRequest, AssignOnCallShiftRequest, AttackAllowlistRequest, AttackAllowlistResponse, AttackBanIdRequest, AttackBanListRequest, AttackBanListResponse, AttackBanResponse, AttackEventListRequest, AttackEventListResponse, AttackEvidenceRequest, AttackEvidenceResponse, AttackOverviewRequest, AttackOverviewResponse, AuditListRequest, AuditListResponse, AvailableJobClassesResponse, BaseInstallScanRequest, BaseInstallScanResponse, BaselineDeviceRequest, BaselineExceptionDto, BaselineExceptionIdRequest, BaselineExceptionListResponse, BaselineFixFormDto, BaselineFixPreviewDto, BaselineFixRequest, BaselineListRequest, BaselineListResponse, BaselineReportDto, BaselineRunDto, BaselineRunListResponse, BaselineRunRequest, BaselineSetExceptionRequest, BulkApplyRequest, BulkResultDto, BulkUpdateRequest, BulkUpgradeRequest, BulkValidateRequest, BulkValidateResponse, BulkValuesRequest, BulkValuesResponse, BxBackupBrowseDto, BxBackupListRequest, BxBackupOverviewDto, BxBackupRepoStatsDto, BxBackupRequest, BxBackupRestoreDto, BxBackupRestoreRequest, BxBackupRestoreStartRequest, BxBackupRestoresDto, CaddyVhostFilesRequest, CaddyVhostFilesResponse, CancelClaudeRunRequest, CancelFileSyncRequest, CancelJobRequest, CertEntryRef, CertFileEntriesRequest, CertFileEntriesResponse, CertImportPreview, CertImportRequest, CertInspectResponse, CertItemDetail, CertItemRef, CertItemUsageRequest, CertItemUsageResponse, CheckNowRequest, CheckNowResponse, ClaimOnCallShiftRequest, ClaudeEventsRequest, ClaudeEventsResponse, ClaudeModelsResponse, ClaudeRunDto, ClaudeRunsRequest, ClaudeRunsResponse, ClaudeSettingsResponse, ClaudeSettingsValues, ClaudeStatsRequest, ClaudeStatsResponse, ClaudeStatusDto, CloseIncidentRequest, CloseIntegrityFindingRequest, CompleteCertChainResponse, ComposeImportScanRequest, ComposeImportScanResponse, ContainerActionResponse, ContainerInspectRequest, ContainerInspectResponse, ContainerKillRequest, ContainerLogsRequest, ContainerLogsResponse, ContainerRestartRequest, CreateAttackBanRequest, CreateCertItemRequest, CreateCveExceptionRequest, CreateCveExceptionResponse, CreateDbTunnelRequest, CreateDbTunnelResponse, CreateDeviceRequest, CreateGlobalMatcherRequest, CreateIncidentRequest, CreateIncidentResponse, CreateInstanceRequest, CreateIntegrityExceptionRequest, CreateIntegrityExceptionResponse, CreateJoinCodeRequest, CreateJoinCodeResponse, CreateRoleRequest, CreateRoleResponse, CreateUpdateJobRequest, CurrentOnCallResponse, CveCoverageRequest, CveCoverageResponse, CveDetailDto, CveDetailRequest, CveDeviceStateDto, CveDeviceStateRequest, CveExceptionsResponse, CveInstanceStateDto, CveInstanceStateRequest, CveListRequest, CveListResponse, CveTreeResponse, DataUsageRequest, DataUsageResponse, DbTunnelSectionDto, DbTunnelSectionRequest, DeleteCommentRequest, DeleteCveExceptionRequest, DeleteDeviceRequest, DeleteDnsOperatorRequest, DeleteEscalationPolicyRequest, DeleteGlobalMatcherRequest, DeleteInstanceRequest, DeleteIntegrityExceptionRequest, DeleteJobRequest, DeleteLabelRequest, DeleteLabelStyleRequest, DeleteLinkRequest, DeleteOnCallMembershipRequest, DeleteOnCallUnavailabilityRequest, DeletePreflightRequest, DeletePreflightResponse, DeleteStaticSiteRequest, DeployableRevisionsRequest, DeployableRevisionsResponse, DeploymentContainersRequest, DeploymentContainersResponse, DeploymentInstanceDto, DeploymentInstanceRef, DeploymentMetricsRequest, DeploymentMetricsSummaryRequest, DeploymentRunDto, DeploymentRunRef, DeploymentUsageResponse, DescribeTemplateRequest, DeviceDetailsRequest, DeviceDetailsResponse, DeviceFactsRequest, DeviceFactsResponse, DeviceOverviewRequest, DeviceOverviewResponse, DeviceSettingsRequest, DeviceSettingsResponse, DiskUsageRequest, DiskUsageResponse, DnsOperatorsRequest, DnsOperatorsResponse, DockerAttributionRequest, DockerAttributionResponse, DockerStatusRequest, DockerStatusResponse, DownloadChunkRequest, DownloadChunkResponse, DownloadFileRequest, DownloadFileResponse, EditCommentRequest, EditIncidentRequest, EditLinkRequest, ExceptFindingsRequest, ExceptFindingsResponse, FetchTlsCertificatesRequest, FileSyncRun, FileSyncRunRef, GetCertItemRequest, GetFileSyncRunRequest, GetGlobalMatcherRequest, GetIncidentRequest, GetInstanceRequest, GetRunRequest, GetTlsReportRequest, GlobalMatcherDto, GlobalMatcherRef, HashPasswordRequest, HashPasswordResponse, HostHealthRequest, HostHealthResponse, ImageDetailRequest, ImageDetailResponse, ImageListRequest, ImageListResponse, IncidentDetails, IncidentTreeResponse, InspectCertFileRequest, InspectCertInputRequest, InspectCertInputResponse, InspectCertUploadRequest, IntegrityChecksResponse, IntegrityDeviceStateDto, IntegrityDeviceStateRequest, IntegrityExceptionsResponse, IntegrityFindingDto, IntegrityListFindingsRequest, IntegrityListFindingsResponse, IntegrityPeerCompareRequest, IntegrityPeerReportDto, IntegrityRunDeviceRequest, IntegrityRunDeviceResponse, IntegrityTreeResponse, JobHistoryRequest, JobHistoryResponse, JoinViaTeleportRequest, KnownJobDetail, KnownJobRequest, KnownJobsResponse, LabelActionResultDto, LabelAdminOverviewResponse, LabelStylesResponse, LabelsRequest, LabelsResponse, LegacyCmsScanRequest, LegacyCmsScanResponse, ListCertItemsRequest, ListCertItemsResponse, ListDirectoryRequest, ListDirectoryResponse, ListEscalationPoliciesResponse, ListFileSyncChildrenRequest, ListFileSyncChildrenResponse, ListFileSyncEventsRequest, ListFileSyncEventsResponse, ListFileSyncRunsRequest, ListFileSyncRunsResponse, ListFilesRequest, ListFilesResponse, ListGlobalMatchersResponse, ListIncidentGroupsResponse, ListIncidentsRequest, ListIncidentsResponse, ListInstancesRequest, ListInstancesResponse, ListPortsRequest, ListPortsResponse, ListRunsRequest, ListRunsResponse, ListTemplatesResponse, ListTlsReportsRequest, ListTlsReportsResponse, ListUsersResponse, MaintenanceWindowRequest, MaintenanceWindowResponse, MaintenanceWindowsRequest, MaintenanceWindowsResponse, McpCatalogResponse, McpGrantsResponse, MeResponse, MentionNotifyDto, MentionsResponse, MergeLabelValuesRequest, MetricsQueryRequest, MetricsQueryResponse, MetricsSummaryRequest, MetricsSummaryResponse, MonitoringStoreResponse, MoveDeviceRequest, NetworkCheckRequest, NetworkCheckResponse, NewKogoconfTokenResponse, OnCallPoolResponse, OnCallRosterRequest, OnCallRosterResponse, PackageChangelogRequest, PackageChangelogResponse, PackageDetailRequest, PackageDetailResponse, PackageListRequest, PackageListResponse, ParseMatcherRequest, ParseMatcherResponse, PauseSensorRequest, PingRequest, PingResponse, PlanDto, PlanRequest, PrerequisitesRequest, PrerequisitesResponse, ProbeAgentsResponse, ReadFileTextRequest, ReadFileTextResponse, RecentTrafficRequest, RecentTrafficResponse, RegenerateConfigsResponse, ReleaseListResponse, RemediateRequest, RemediateResponse, RemoveJobRequest, RemoveLabelRequest, RenameLabelKeyRequest, RenameLabelValueRequest, RenderMatcherRequest, RenderMatcherResponse, RenewCertRequest, ReopenIncidentRequest, ReorderDnsOperatorsRequest, RescopeAttackBanRequest, ResolveDnsRequest, ResolveDnsResponse, ResolveIncidentRefsRequest, ResolveIncidentRefsResponse, RevealSecretRequest, RevealSecretResponse, RevokeDbTunnelRequest, RevokeMcpGrantRequest, RunJobRequest, RunJobResponse, RunRequest, RunResponse, RunningJobsResponse, SaveDnsOperatorRequest, SaveEscalationPolicyRequest, SaveEscalationPolicyResponse, SaveInstanceResponse, SaveMaintenanceWindowRequest, SaveOnCallDayTimesRequest, SaveOnCallMembershipRequest, SaveOnCallMembershipResponse, SaveOnCallUnavailabilityRequest, SaveOnCallUnavailabilityResponse, SaveOwnUnavailabilityRequest, SaveSensorReportRequest, SaveSensorRequest, SearchFilesRequest, SearchFilesResponse, SendSensorReportRequest, SendSensorReportResponse, SensorDetailsResponse, SensorHistoryRequest, SensorHistoryResponse, SensorListRequest, SensorListResponse, SensorOutputHistoryRequest, SensorOutputHistoryResponse, SensorReportPreviewResponse, SensorReportRequest, SensorReportResponse, SensorReportsResponse, SensorRequest, SensorTreeResponse, ServerTrafficRequest, ServerTrafficResponse, ServiceStatusRequest, ServiceStatusResponse, ServiceUnitRequest, ServiceUnitResponse, SetAgentExpectedRequest, SetDbTunnelAddressRequest, SetDeviceSettingRequest, SetFrameLoggingRequest, SetGroupRolesRequest, SetLabelRequest, SetLabelStyleRequest, SetLimitsRequest, SetMentionNotifyRequest, SetOwnPhoneRequest, SetPhoneResponse, SetRolePermissionsRequest, SetSlackIdResponse, SetTemplateSensorsRequest, SetUserIncidentGroupsRequest, SetUserPhoneRequest, SetUserRolesRequest, SetUserSlackIdRequest, StartFileSyncRequest, StartTlsCheckRequest, StaticSiteDto, StopSchedulerRequest, StructuredPreviewRequest, StructuredPreviewResponse, SystemMetricsRequest, SystemMetricsResponse, TeleportVersionsResponse, TemplateSchemaDto, TestNotificationChannelRequest, TestNotificationChannelResponse, TlsReport, TlsReportRef, TrafficByDeviceRequest, TrafficByDeviceResponse, TrafficLogsRequest, TrafficLogsResponse, TrafficRequestsRequest, TrafficRequestsResponse, UnackIncidentRequest, UnassignIncidentRequest, UndeployRequest, UninstallAgentRequest, UnitPropertiesRequest, UnitPropertiesResponse, UnusedTemplateRevisionsResponse, UpdateAgentRequest, UpdateAllRequest, UpdateCveExceptionRequest, UpdateDeviceRequest, UpdateDeviceResponse, UpdateDeviceStateDto, UpdateDeviceStateRequest, UpdateGlobalMatcherRequest, UpdateInstanceRequest, UpdateIntegrityExceptionRequest, UpdateListRequest, UpdateListResponse, UpdateRoleRequest, UpdateRunDeviceRequest, UpdateRunDeviceResponse, UpdateTreeResponse, UpgradeInstanceRequest, UsageOverviewRequest, UsageOverviewResponse, UsageRequest, ValidateRequest, ValidationResultDto, VerifyRequest, VerifyResultDto } from "./models";

// Endpoints not in the generated client (hand-write / wire separately):
//   - agent/download (server_only)
//   - agent/read (server_only)
//   - agent/uploadFile (special)
//   - auth/login (special)
//   - auth/process (server_only)
//   - certTool/download (special)
//   - certTool/downloadZip (special)
//   - certTool/uploadCert (special)
//   - content/uploadFile (special)
//   - staticSites/create (special)
//   - staticSites/update (special)

export interface OpsApiTransport {
  /** POST {baseUrl}/{path} with an optional JSON body; resolves to the parsed JSON (or undefined for empty/204). */
  call<R>(path: string, body?: unknown): Promise<R>;
}

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

/** User-facing message for an API error: the server's plain-text body, else the fallback. */
export function apiErrorMessage(e: unknown, fallback: string): string {
  return e instanceof ApiError && e.message ? e.message : fallback;
}

export interface FetchTransportOptions {
  /** API base path; defaults to "/api". */
  baseUrl?: string;
  /** Returns the current bearer token (from the auth store), if any. */
  getToken?: () => string | null | undefined;
  /** Called when a request returns 401 (e.g. to lock the session out). */
  onUnauthorized?: () => void;
}

export function createFetchTransport(options: FetchTransportOptions = {}): OpsApiTransport {
  const baseUrl = options.baseUrl ?? "/api";
  return {
    async call<R>(path: string, body?: unknown): Promise<R> {
      const headers: Record<string, string> = {};
      const token = options.getToken?.();
      if (token) headers["Authorization"] = `Bearer ${token}`;

      const init: RequestInit = { method: "POST", headers };
      if (body !== undefined && body !== null) {
        headers["Content-Type"] = "application/json";
        init.body = JSON.stringify(body);
      }

      const res = await fetch(`${baseUrl}/${path}`, init);

      if (res.status === 401) options.onUnauthorized?.();

      if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new ApiError(res.status, text);
      }

      if (res.status === 204) return undefined as R;
      const text = await res.text();
      return (text ? JSON.parse(text) : undefined) as R;
    },
  };
}

export interface AgentApi {
  containerInspect(request: ContainerInspectRequest): Promise<ContainerInspectResponse>;
  containerKill(request: ContainerKillRequest): Promise<ContainerActionResponse>;
  containerLogs(request: ContainerLogsRequest): Promise<ContainerLogsResponse>;
  containerRestart(request: ContainerRestartRequest): Promise<ContainerActionResponse>;
  createDownload(request: DownloadFileRequest): Promise<DownloadFileResponse>;
  createJoinCode(request: CreateJoinCodeRequest): Promise<CreateJoinCodeResponse>;
  diskUsage(request: DiskUsageRequest): Promise<DiskUsageResponse>;
  dockerAttribution(request: DockerAttributionRequest): Promise<DockerAttributionResponse>;
  dockerStatus(request: DockerStatusRequest): Promise<DockerStatusResponse>;
  downloadFile(request: DownloadChunkRequest): Promise<DownloadChunkResponse>;
  entries(request: ListDirectoryRequest): Promise<ListDirectoryResponse>;
  joinViaTeleport(request: JoinViaTeleportRequest): Promise<void>;
  listFiles(request: ListFilesRequest): Promise<ListFilesResponse>;
  listPorts(request: ListPortsRequest): Promise<ListPortsResponse>;
  metrics(request: SystemMetricsRequest): Promise<SystemMetricsResponse>;
  networkCheck(request: NetworkCheckRequest): Promise<NetworkCheckResponse>;
  ping(request: PingRequest): Promise<PingResponse>;
  readFile(request: ReadFileTextRequest): Promise<ReadFileTextResponse>;
  searchFiles(request: SearchFilesRequest): Promise<SearchFilesResponse>;
  serviceStatus(request: ServiceStatusRequest): Promise<ServiceStatusResponse>;
  serviceUnit(request: ServiceUnitRequest): Promise<ServiceUnitResponse>;
  setAgentExpected(request: SetAgentExpectedRequest): Promise<void>;
  setFrameLogging(request: SetFrameLoggingRequest): Promise<void>;
  uninstall(request: UninstallAgentRequest): Promise<void>;
  unitProperties(request: UnitPropertiesRequest): Promise<UnitPropertiesResponse>;
  update(request: UpdateAgentRequest): Promise<void>;
  updateAll(request: UpdateAllRequest): Promise<void>;
  versions(): Promise<AgentVersionsResponse>;
}

export interface AttackApi {
  allowlist(request: AttackAllowlistRequest): Promise<AttackAllowlistResponse>;
  ban(request: CreateAttackBanRequest): Promise<AttackBanResponse>;
  bans(request?: AttackBanListRequest): Promise<AttackBanListResponse>;
  events(request: AttackEventListRequest): Promise<AttackEventListResponse>;
  evidence(request: AttackEvidenceRequest): Promise<AttackEvidenceResponse>;
  overview(request: AttackOverviewRequest): Promise<AttackOverviewResponse>;
  rescopeBan(request: RescopeAttackBanRequest): Promise<AttackBanResponse>;
  unban(request: AttackBanIdRequest): Promise<AttackBanResponse>;
}

export interface AuditApi {
  list(request?: AuditListRequest): Promise<AuditListResponse>;
}

export interface AuthApi {
  adminCreateRole(request: CreateRoleRequest): Promise<CreateRoleResponse>;
  adminDeleteLabelStyle(request: DeleteLabelStyleRequest): Promise<LabelStylesResponse>;
  adminMergeLabelValues(request: MergeLabelValuesRequest): Promise<LabelActionResultDto>;
  adminOverview(): Promise<AdminOverviewResponse>;
  adminRemoveLabel(request: RemoveLabelRequest): Promise<LabelActionResultDto>;
  adminRenameLabelKey(request: RenameLabelKeyRequest): Promise<LabelActionResultDto>;
  adminRenameLabelValue(request: RenameLabelValueRequest): Promise<LabelActionResultDto>;
  adminSetGroupRoles(request: SetGroupRolesRequest): Promise<void>;
  adminSetLabelStyle(request: SetLabelStyleRequest): Promise<LabelStylesResponse>;
  adminSetRolePermissions(request: SetRolePermissionsRequest): Promise<void>;
  adminSetUserIncidentGroups(request: SetUserIncidentGroupsRequest): Promise<void>;
  adminSetUserPhone(request: SetUserPhoneRequest): Promise<SetPhoneResponse>;
  adminSetUserRoles(request: SetUserRolesRequest): Promise<void>;
  adminSetUserSlackId(request: SetUserSlackIdRequest): Promise<SetSlackIdResponse>;
  adminUpdateRole(request: UpdateRoleRequest): Promise<void>;
  labelOverview(): Promise<LabelAdminOverviewResponse>;
  labelStyles(): Promise<LabelStylesResponse>;
  listMcpGrants(): Promise<McpGrantsResponse>;
  listUsers(): Promise<ListUsersResponse>;
  me(): Promise<MeResponse>;
  newKogoconfToken(): Promise<NewKogoconfTokenResponse>;
  revokeMcpGrant(request: RevokeMcpGrantRequest): Promise<void>;
  setOwnMentionNotify(request: SetMentionNotifyRequest): Promise<MentionNotifyDto>;
  setOwnPhone(request: SetOwnPhoneRequest): Promise<SetPhoneResponse>;
}

export interface BaselineApi {
  allExceptions(): Promise<BaselineExceptionListResponse>;
  applyFix(request: BaselineFixRequest): Promise<BaselineRunDto>;
  checkNow(request: BaselineDeviceRequest): Promise<BaselineReportDto>;
  deleteException(request: BaselineExceptionIdRequest): Promise<void>;
  deviceReport(request: BaselineDeviceRequest): Promise<BaselineReportDto>;
  exceptions(request: BaselineDeviceRequest): Promise<BaselineExceptionListResponse>;
  fixForm(request: BaselineFixRequest): Promise<BaselineFixFormDto>;
  list(request: BaselineListRequest): Promise<BaselineListResponse>;
  previewFix(request: BaselineFixRequest): Promise<BaselineFixPreviewDto>;
  run(request: BaselineRunRequest): Promise<BaselineRunDto>;
  runs(request: BaselineDeviceRequest): Promise<BaselineRunListResponse>;
  setException(request: BaselineSetExceptionRequest): Promise<BaselineExceptionDto>;
}

export interface BxBackupApi {
  browseClose(request: BxBackupRequest): Promise<BxBackupBrowseDto>;
  browseOpen(request: BxBackupRequest): Promise<BxBackupBrowseDto>;
  browseStatus(request: BxBackupRequest): Promise<BxBackupBrowseDto>;
  listSnapshotDirectory(request: BxBackupListRequest): Promise<ListDirectoryResponse>;
  overview(request: BxBackupRequest): Promise<BxBackupOverviewDto>;
  repoStats(request: BxBackupRequest): Promise<BxBackupRepoStatsDto>;
  restoreCancel(request: BxBackupRestoreRequest): Promise<BxBackupRestoreDto>;
  restoreList(request: BxBackupRequest): Promise<BxBackupRestoresDto>;
  restoreStart(request: BxBackupRestoreStartRequest): Promise<BxBackupRestoreDto>;
  restoreStatus(request: BxBackupRestoreRequest): Promise<BxBackupRestoreDto>;
}

export interface CertToolApi {
  completeChain(request: CertEntryRef): Promise<CompleteCertChainResponse>;
  createItem(request: CreateCertItemRequest): Promise<CertItemRef>;
  deleteEntry(request: CertEntryRef): Promise<void>;
  deleteItem(request: CertItemRef): Promise<void>;
  getItem(request: GetCertItemRequest): Promise<CertItemDetail>;
  importCertificate(request: CertImportRequest): Promise<CertItemDetail>;
  inspect(request: InspectCertInputRequest): Promise<InspectCertInputResponse>;
  listItems(request: ListCertItemsRequest): Promise<ListCertItemsResponse>;
  previewImport(request: CertImportRequest): Promise<CertImportPreview>;
  renew(request: RenewCertRequest): Promise<CertItemDetail>;
}

export interface CertViewerApi {
  inspectFile(request: InspectCertFileRequest): Promise<CertInspectResponse>;
  inspectUpload(request: InspectCertUploadRequest): Promise<CertInspectResponse>;
}

export interface ChangelogApi {
  list(): Promise<ReleaseListResponse>;
}

export interface ClaudeApi {
  ask(request: AskClaudeRequest): Promise<ClaudeRunDto>;
  cancel(request: CancelClaudeRunRequest): Promise<void>;
  events(request: ClaudeEventsRequest): Promise<ClaudeEventsResponse>;
  models(): Promise<ClaudeModelsResponse>;
  runs(request: ClaudeRunsRequest): Promise<ClaudeRunsResponse>;
  saveSettings(request: ClaudeSettingsValues): Promise<void>;
  settings(): Promise<ClaudeSettingsResponse>;
  stats(request: ClaudeStatsRequest): Promise<ClaudeStatsResponse>;
  status(): Promise<ClaudeStatusDto>;
}

export interface CveApi {
  coverage(request: CveCoverageRequest): Promise<CveCoverageResponse>;
  createException(request: CreateCveExceptionRequest): Promise<CreateCveExceptionResponse>;
  deleteException(request: DeleteCveExceptionRequest): Promise<CveExceptionsResponse>;
  detail(request: CveDetailRequest): Promise<CveDetailDto>;
  deviceState(request: CveDeviceStateRequest): Promise<CveDeviceStateDto>;
  instanceState(request: CveInstanceStateRequest): Promise<CveInstanceStateDto>;
  list(request: CveListRequest): Promise<CveListResponse>;
  listExceptions(): Promise<CveExceptionsResponse>;
  tree(): Promise<CveTreeResponse>;
  updateException(request: UpdateCveExceptionRequest): Promise<CveExceptionsResponse>;
}

export interface DbTunnelApi {
  create(request: CreateDbTunnelRequest): Promise<CreateDbTunnelResponse>;
  revoke(request: RevokeDbTunnelRequest): Promise<void>;
  section(request: DbTunnelSectionRequest): Promise<DbTunnelSectionDto>;
  setAddress(request: SetDbTunnelAddressRequest): Promise<void>;
}

export interface DeploymentApi {
  apply(request: ApplyRequest): Promise<DeploymentRunRef>;
  bulkApply(request: BulkApplyRequest): Promise<BulkResultDto>;
  bulkUpdate(request: BulkUpdateRequest): Promise<BulkResultDto>;
  bulkUpgrade(request: BulkUpgradeRequest): Promise<BulkResultDto>;
  bulkValidate(request: BulkValidateRequest): Promise<BulkValidateResponse>;
  bulkValues(request: BulkValuesRequest): Promise<BulkValuesResponse>;
  caddyVhostFiles(request: CaddyVhostFilesRequest): Promise<CaddyVhostFilesResponse>;
  certItemUsage(request: CertItemUsageRequest): Promise<CertItemUsageResponse>;
  containers(request: DeploymentContainersRequest): Promise<DeploymentContainersResponse>;
  createGlobalMatcher(request: CreateGlobalMatcherRequest): Promise<GlobalMatcherRef>;
  createInstance(request: CreateInstanceRequest): Promise<SaveInstanceResponse>;
  dataUsage(request: DataUsageRequest): Promise<DataUsageResponse>;
  deleteGlobalMatcher(request: DeleteGlobalMatcherRequest): Promise<GlobalMatcherRef>;
  deleteInstance(request: DeleteInstanceRequest): Promise<DeploymentInstanceRef>;
  deleteLabel(request: DeleteLabelRequest): Promise<LabelsResponse>;
  deletePreflight(request: DeletePreflightRequest): Promise<DeletePreflightResponse>;
  deployableRevisions(request: DeployableRevisionsRequest): Promise<DeployableRevisionsResponse>;
  describeTemplate(request: DescribeTemplateRequest): Promise<TemplateSchemaDto>;
  getGlobalMatcher(request: GetGlobalMatcherRequest): Promise<GlobalMatcherDto>;
  getInstance(request: GetInstanceRequest): Promise<DeploymentInstanceDto>;
  getRun(request: GetRunRequest): Promise<DeploymentRunDto>;
  hashEditorPassword(request: HashPasswordRequest): Promise<HashPasswordResponse>;
  instancesWithDependencyUpdate(): Promise<ListInstancesResponse>;
  labels(request: LabelsRequest): Promise<LabelsResponse>;
  listGlobalMatchers(): Promise<ListGlobalMatchersResponse>;
  listInstances(request: ListInstancesRequest): Promise<ListInstancesResponse>;
  listRuns(request: ListRunsRequest): Promise<ListRunsResponse>;
  listTemplates(): Promise<ListTemplatesResponse>;
  parseMatcher(request: ParseMatcherRequest): Promise<ParseMatcherResponse>;
  plan(request: PlanRequest): Promise<PlanDto>;
  prerequisites(request: PrerequisitesRequest): Promise<PrerequisitesResponse>;
  recentTraffic(request: RecentTrafficRequest): Promise<RecentTrafficResponse>;
  renderMatcher(request: RenderMatcherRequest): Promise<RenderMatcherResponse>;
  renderStructuredPreview(request: StructuredPreviewRequest): Promise<StructuredPreviewResponse>;
  revealSecret(request: RevealSecretRequest): Promise<RevealSecretResponse>;
  scanBaseInstall(request: BaseInstallScanRequest): Promise<BaseInstallScanResponse>;
  scanComposeProject(request: ComposeImportScanRequest): Promise<ComposeImportScanResponse>;
  scanLegacyCms(request: LegacyCmsScanRequest): Promise<LegacyCmsScanResponse>;
  serverTraffic(request: ServerTrafficRequest): Promise<ServerTrafficResponse>;
  setLabel(request: SetLabelRequest): Promise<LabelsResponse>;
  setLimits(request: SetLimitsRequest): Promise<DeploymentInstanceDto>;
  setTemplateSensors(request: SetTemplateSensorsRequest): Promise<DeploymentInstanceDto>;
  trafficByDevice(request: TrafficByDeviceRequest): Promise<TrafficByDeviceResponse>;
  trafficLogs(request: TrafficLogsRequest): Promise<TrafficLogsResponse>;
  trafficRequests(request: TrafficRequestsRequest): Promise<TrafficRequestsResponse>;
  undeploy(request: UndeployRequest): Promise<DeploymentRunRef>;
  unusedTemplateRevisions(): Promise<UnusedTemplateRevisionsResponse>;
  updateGlobalMatcher(request: UpdateGlobalMatcherRequest): Promise<GlobalMatcherRef>;
  updateInstance(request: UpdateInstanceRequest): Promise<SaveInstanceResponse>;
  upgradeInstance(request: UpgradeInstanceRequest): Promise<DeploymentInstanceRef>;
  usage(request: UsageRequest): Promise<DeploymentUsageResponse>;
  usageOverview(request: UsageOverviewRequest): Promise<UsageOverviewResponse>;
  validate(request: ValidateRequest): Promise<ValidationResultDto>;
  verify(request: VerifyRequest): Promise<VerifyResultDto>;
}

export interface DeviceApi {
  create(request: CreateDeviceRequest): Promise<DeviceOverviewResponse>;
  delete(request: DeleteDeviceRequest): Promise<void>;
  deleteLabel(request: DeleteLabelRequest): Promise<LabelsResponse>;
  details(request: DeviceDetailsRequest): Promise<DeviceDetailsResponse>;
  facts(request?: DeviceFactsRequest): Promise<DeviceFactsResponse>;
  labels(request: LabelsRequest): Promise<LabelsResponse>;
  move(request: MoveDeviceRequest): Promise<DeviceOverviewResponse>;
  overview(request?: DeviceOverviewRequest): Promise<DeviceOverviewResponse>;
  setLabel(request: SetLabelRequest): Promise<LabelsResponse>;
  setSetting(request: SetDeviceSettingRequest): Promise<DeviceSettingsResponse>;
  settings(request: DeviceSettingsRequest): Promise<DeviceSettingsResponse>;
  update(request: UpdateDeviceRequest): Promise<UpdateDeviceResponse>;
}

export interface DnsApi {
  deleteOperator(request: DeleteDnsOperatorRequest): Promise<DnsOperatorsResponse>;
  operators(request: DnsOperatorsRequest): Promise<DnsOperatorsResponse>;
  reorderOperators(request: ReorderDnsOperatorsRequest): Promise<DnsOperatorsResponse>;
  resolve(request: ResolveDnsRequest): Promise<ResolveDnsResponse>;
  saveOperator(request: SaveDnsOperatorRequest): Promise<DnsOperatorsResponse>;
}

export interface FileSyncApi {
  cancel(request: CancelFileSyncRequest): Promise<FileSyncRunRef>;
  get(request: GetFileSyncRunRequest): Promise<FileSyncRun>;
  list(request: ListFileSyncRunsRequest): Promise<ListFileSyncRunsResponse>;
  listChildren(request: ListFileSyncChildrenRequest): Promise<ListFileSyncChildrenResponse>;
  listEvents(request: ListFileSyncEventsRequest): Promise<ListFileSyncEventsResponse>;
  start(request: StartFileSyncRequest): Promise<FileSyncRunRef>;
}

export interface ImageApi {
  detail(request: ImageDetailRequest): Promise<ImageDetailResponse>;
  list(request?: ImageListRequest): Promise<ImageListResponse>;
}

export interface IncidentApi {
  ack(request: AckIncidentRequest): Promise<void>;
  addComment(request: AddCommentRequest): Promise<MentionsResponse>;
  addLink(request: AddLinkRequest): Promise<void>;
  assign(request: AssignIncidentRequest): Promise<void>;
  close(request: CloseIncidentRequest): Promise<void>;
  create(request: CreateIncidentRequest): Promise<CreateIncidentResponse>;
  deleteComment(request: DeleteCommentRequest): Promise<void>;
  deleteEscalationPolicy(request: DeleteEscalationPolicyRequest): Promise<void>;
  deleteLink(request: DeleteLinkRequest): Promise<void>;
  edit(request: EditIncidentRequest): Promise<MentionsResponse>;
  editComment(request: EditCommentRequest): Promise<MentionsResponse>;
  editLink(request: EditLinkRequest): Promise<void>;
  get(request: GetIncidentRequest): Promise<IncidentDetails>;
  list(request: ListIncidentsRequest): Promise<ListIncidentsResponse>;
  listEscalationPolicies(): Promise<ListEscalationPoliciesResponse>;
  listGroups(): Promise<ListIncidentGroupsResponse>;
  remediate(request: RemediateRequest): Promise<RemediateResponse>;
  reopen(request: ReopenIncidentRequest): Promise<void>;
  resolveRefs(request: ResolveIncidentRefsRequest): Promise<ResolveIncidentRefsResponse>;
  saveEscalationPolicy(request: SaveEscalationPolicyRequest): Promise<SaveEscalationPolicyResponse>;
  testNotificationChannel(request: TestNotificationChannelRequest): Promise<TestNotificationChannelResponse>;
  tree(): Promise<IncidentTreeResponse>;
  unack(request: UnackIncidentRequest): Promise<void>;
  unassign(request: UnassignIncidentRequest): Promise<void>;
}

export interface InfrastructureApi {
  teleportVersions(): Promise<TeleportVersionsResponse>;
}

export interface IntegrityApi {
  adoptBaseline(request: AdoptBaselineRequest): Promise<AdoptBaselineResponse>;
  checks(): Promise<IntegrityChecksResponse>;
  closeFinding(request: CloseIntegrityFindingRequest): Promise<IntegrityFindingDto>;
  createException(request: CreateIntegrityExceptionRequest): Promise<CreateIntegrityExceptionResponse>;
  deleteException(request: DeleteIntegrityExceptionRequest): Promise<IntegrityExceptionsResponse>;
  deviceState(request: IntegrityDeviceStateRequest): Promise<IntegrityDeviceStateDto>;
  exceptFindings(request: ExceptFindingsRequest): Promise<ExceptFindingsResponse>;
  listExceptions(): Promise<IntegrityExceptionsResponse>;
  listFindings(request: IntegrityListFindingsRequest): Promise<IntegrityListFindingsResponse>;
  peerCompare(request: IntegrityPeerCompareRequest): Promise<IntegrityPeerReportDto>;
  runDevice(request: IntegrityRunDeviceRequest): Promise<IntegrityRunDeviceResponse>;
  tree(): Promise<IntegrityTreeResponse>;
  updateException(request: UpdateIntegrityExceptionRequest): Promise<IntegrityExceptionsResponse>;
}

export interface McpApi {
  catalog(): Promise<McpCatalogResponse>;
}

export interface MetricsApi {
  deploymentQuery(request: DeploymentMetricsRequest): Promise<MetricsQueryResponse>;
  deploymentSummarize(request: DeploymentMetricsSummaryRequest): Promise<MetricsSummaryResponse>;
  hostHealth(request: HostHealthRequest): Promise<HostHealthResponse>;
  monitoringStore(): Promise<MonitoringStoreResponse>;
  query(request: MetricsQueryRequest): Promise<MetricsQueryResponse>;
  summarize(request: MetricsSummaryRequest): Promise<MetricsSummaryResponse>;
}

export interface OnCallApi {
  assignShift(request: AssignOnCallShiftRequest): Promise<void>;
  claimShift(request: ClaimOnCallShiftRequest): Promise<void>;
  current(): Promise<CurrentOnCallResponse>;
  deleteMembership(request: DeleteOnCallMembershipRequest): Promise<void>;
  deleteOwnUnavailability(request: DeleteOnCallUnavailabilityRequest): Promise<void>;
  deleteUnavailability(request: DeleteOnCallUnavailabilityRequest): Promise<void>;
  pool(): Promise<OnCallPoolResponse>;
  roster(request: OnCallRosterRequest): Promise<OnCallRosterResponse>;
  saveDayTimes(request: SaveOnCallDayTimesRequest): Promise<void>;
  saveMembership(request: SaveOnCallMembershipRequest): Promise<SaveOnCallMembershipResponse>;
  saveOwnUnavailability(request: SaveOwnUnavailabilityRequest): Promise<SaveOnCallUnavailabilityResponse>;
  saveUnavailability(request: SaveOnCallUnavailabilityRequest): Promise<SaveOnCallUnavailabilityResponse>;
}

export interface PackageApi {
  detail(request: PackageDetailRequest): Promise<PackageDetailResponse>;
  list(request?: PackageListRequest): Promise<PackageListResponse>;
}

export interface SchedulerApi {
  availableJobClasses(): Promise<AvailableJobClassesResponse>;
  cancelJob(request: CancelJobRequest): Promise<void>;
  createUpdateJob(request: CreateUpdateJobRequest): Promise<KnownJobDetail>;
  deleteJob(request: DeleteJobRequest): Promise<void>;
  disableJob(request: RemoveJobRequest): Promise<void>;
  enableJob(request: AddJobRequest): Promise<void>;
  history(request: JobHistoryRequest): Promise<JobHistoryResponse>;
  knownJob(request: KnownJobRequest): Promise<KnownJobDetail>;
  knownJobs(): Promise<KnownJobsResponse>;
  run(request: RunRequest): Promise<RunResponse>;
  runJob(request: RunJobRequest): Promise<RunJobResponse>;
  runningJobs(): Promise<RunningJobsResponse>;
  start(): Promise<void>;
  stop(request: StopSchedulerRequest): Promise<void>;
}

export interface SensorApi {
  certFileEntries(request: CertFileEntriesRequest): Promise<CertFileEntriesResponse>;
  checkNow(request: CheckNowRequest): Promise<CheckNowResponse>;
  delete(request: SensorRequest): Promise<void>;
  deleteReport(request: SensorReportRequest): Promise<SensorReportsResponse>;
  deleteWindow(request: MaintenanceWindowRequest): Promise<MaintenanceWindowsResponse>;
  get(request: SensorRequest): Promise<SensorDetailsResponse>;
  getReport(request: SensorReportRequest): Promise<SensorReportResponse>;
  getWindow(request: MaintenanceWindowRequest): Promise<MaintenanceWindowResponse>;
  history(request: SensorHistoryRequest): Promise<SensorHistoryResponse>;
  list(request?: SensorListRequest): Promise<SensorListResponse>;
  outputHistory(request: SensorOutputHistoryRequest): Promise<SensorOutputHistoryResponse>;
  pause(request: PauseSensorRequest): Promise<SensorDetailsResponse>;
  previewReport(request: SensorReportRequest): Promise<SensorReportPreviewResponse>;
  probeAgents(): Promise<ProbeAgentsResponse>;
  reports(): Promise<SensorReportsResponse>;
  resume(request: SensorRequest): Promise<SensorDetailsResponse>;
  save(request: SaveSensorRequest): Promise<SensorDetailsResponse>;
  saveReport(request: SaveSensorReportRequest): Promise<SensorReportResponse>;
  saveWindow(request: SaveMaintenanceWindowRequest): Promise<MaintenanceWindowsResponse>;
  sendReport(request: SendSensorReportRequest): Promise<SendSensorReportResponse>;
  tree(): Promise<SensorTreeResponse>;
  windows(request: MaintenanceWindowsRequest): Promise<MaintenanceWindowsResponse>;
}

export interface StaticSitesApi {
  delete(request: DeleteStaticSiteRequest): Promise<void>;
  deleteLabel(request: DeleteLabelRequest): Promise<LabelsResponse>;
  labels(request: LabelsRequest): Promise<LabelsResponse>;
  list(): Promise<StaticSiteDto[]>;
  regenerateConfigs(): Promise<RegenerateConfigsResponse>;
  setLabel(request: SetLabelRequest): Promise<LabelsResponse>;
}

export interface TlsApi {
  certificates(request: FetchTlsCertificatesRequest): Promise<TlsReport>;
  get(request: GetTlsReportRequest): Promise<TlsReport>;
  list(request: ListTlsReportsRequest): Promise<ListTlsReportsResponse>;
  start(request: StartTlsCheckRequest): Promise<TlsReportRef>;
}

export interface UpdateApi {
  deviceState(request: UpdateDeviceStateRequest): Promise<UpdateDeviceStateDto>;
  list(request: UpdateListRequest): Promise<UpdateListResponse>;
  packageChangelog(request: PackageChangelogRequest): Promise<PackageChangelogResponse>;
  runDevice(request: UpdateRunDeviceRequest): Promise<UpdateRunDeviceResponse>;
  tree(): Promise<UpdateTreeResponse>;
}

export interface GeneratedOpsApi {
  agent: AgentApi;
  attacks: AttackApi;
  audit: AuditApi;
  auth: AuthApi;
  baseline: BaselineApi;
  bxBackup: BxBackupApi;
  certTool: CertToolApi;
  certViewer: CertViewerApi;
  changelog: ChangelogApi;
  claude: ClaudeApi;
  cve: CveApi;
  dbTunnel: DbTunnelApi;
  deployment: DeploymentApi;
  device: DeviceApi;
  dns: DnsApi;
  fileSync: FileSyncApi;
  images: ImageApi;
  incident: IncidentApi;
  infrastructure: InfrastructureApi;
  integrity: IntegrityApi;
  mcp: McpApi;
  metrics: MetricsApi;
  oncall: OnCallApi;
  packages: PackageApi;
  scheduler: SchedulerApi;
  sensor: SensorApi;
  staticSites: StaticSitesApi;
  tls: TlsApi;
  updates: UpdateApi;
}

export function createGeneratedOpsApi(transport: OpsApiTransport): GeneratedOpsApi {
  return {
    agent: {
      containerInspect: (request) => transport.call("agent/containerInspect", request),
      containerKill: (request) => transport.call("agent/containerKill", request),
      containerLogs: (request) => transport.call("agent/containerLogs", request),
      containerRestart: (request) => transport.call("agent/containerRestart", request),
      createDownload: (request) => transport.call("agent/createDownload", request),
      createJoinCode: (request) => transport.call("agent/createJoinCode", request),
      diskUsage: (request) => transport.call("agent/diskUsage", request),
      dockerAttribution: (request) => transport.call("agent/dockerAttribution", request),
      dockerStatus: (request) => transport.call("agent/dockerStatus", request),
      downloadFile: (request) => transport.call("agent/downloadFile", request),
      entries: (request) => transport.call("agent/entries", request),
      joinViaTeleport: (request) => transport.call("agent/joinViaTeleport", request),
      listFiles: (request) => transport.call("agent/listFiles", request),
      listPorts: (request) => transport.call("agent/listPorts", request),
      metrics: (request) => transport.call("agent/metrics", request),
      networkCheck: (request) => transport.call("agent/networkCheck", request),
      ping: (request) => transport.call("agent/ping", request),
      readFile: (request) => transport.call("agent/readFile", request),
      searchFiles: (request) => transport.call("agent/searchFiles", request),
      serviceStatus: (request) => transport.call("agent/serviceStatus", request),
      serviceUnit: (request) => transport.call("agent/serviceUnit", request),
      setAgentExpected: (request) => transport.call("agent/setAgentExpected", request),
      setFrameLogging: (request) => transport.call("agent/setFrameLogging", request),
      uninstall: (request) => transport.call("agent/uninstall", request),
      unitProperties: (request) => transport.call("agent/unitProperties", request),
      update: (request) => transport.call("agent/update", request),
      updateAll: (request) => transport.call("agent/updateAll", request),
      versions: () => transport.call("agent/versions"),
    },
    attacks: {
      allowlist: (request) => transport.call("attacks/allowlist", request),
      ban: (request) => transport.call("attacks/ban", request),
      bans: (request) => transport.call("attacks/bans", request),
      events: (request) => transport.call("attacks/events", request),
      evidence: (request) => transport.call("attacks/evidence", request),
      overview: (request) => transport.call("attacks/overview", request),
      rescopeBan: (request) => transport.call("attacks/rescopeBan", request),
      unban: (request) => transport.call("attacks/unban", request),
    },
    audit: {
      list: (request) => transport.call("audit/list", request),
    },
    auth: {
      adminCreateRole: (request) => transport.call("auth/adminCreateRole", request),
      adminDeleteLabelStyle: (request) => transport.call("auth/adminDeleteLabelStyle", request),
      adminMergeLabelValues: (request) => transport.call("auth/adminMergeLabelValues", request),
      adminOverview: () => transport.call("auth/adminOverview"),
      adminRemoveLabel: (request) => transport.call("auth/adminRemoveLabel", request),
      adminRenameLabelKey: (request) => transport.call("auth/adminRenameLabelKey", request),
      adminRenameLabelValue: (request) => transport.call("auth/adminRenameLabelValue", request),
      adminSetGroupRoles: (request) => transport.call("auth/adminSetGroupRoles", request),
      adminSetLabelStyle: (request) => transport.call("auth/adminSetLabelStyle", request),
      adminSetRolePermissions: (request) => transport.call("auth/adminSetRolePermissions", request),
      adminSetUserIncidentGroups: (request) => transport.call("auth/adminSetUserIncidentGroups", request),
      adminSetUserPhone: (request) => transport.call("auth/adminSetUserPhone", request),
      adminSetUserRoles: (request) => transport.call("auth/adminSetUserRoles", request),
      adminSetUserSlackId: (request) => transport.call("auth/adminSetUserSlackId", request),
      adminUpdateRole: (request) => transport.call("auth/adminUpdateRole", request),
      labelOverview: () => transport.call("auth/labelOverview"),
      labelStyles: () => transport.call("auth/labelStyles"),
      listMcpGrants: () => transport.call("auth/listMcpGrants"),
      listUsers: () => transport.call("auth/listUsers"),
      me: () => transport.call("auth/me"),
      newKogoconfToken: () => transport.call("auth/newKogoconfToken"),
      revokeMcpGrant: (request) => transport.call("auth/revokeMcpGrant", request),
      setOwnMentionNotify: (request) => transport.call("auth/setOwnMentionNotify", request),
      setOwnPhone: (request) => transport.call("auth/setOwnPhone", request),
    },
    baseline: {
      allExceptions: () => transport.call("baseline/allExceptions"),
      applyFix: (request) => transport.call("baseline/applyFix", request),
      checkNow: (request) => transport.call("baseline/checkNow", request),
      deleteException: (request) => transport.call("baseline/deleteException", request),
      deviceReport: (request) => transport.call("baseline/deviceReport", request),
      exceptions: (request) => transport.call("baseline/exceptions", request),
      fixForm: (request) => transport.call("baseline/fixForm", request),
      list: (request) => transport.call("baseline/list", request),
      previewFix: (request) => transport.call("baseline/previewFix", request),
      run: (request) => transport.call("baseline/run", request),
      runs: (request) => transport.call("baseline/runs", request),
      setException: (request) => transport.call("baseline/setException", request),
    },
    bxBackup: {
      browseClose: (request) => transport.call("bxBackup/browseClose", request),
      browseOpen: (request) => transport.call("bxBackup/browseOpen", request),
      browseStatus: (request) => transport.call("bxBackup/browseStatus", request),
      listSnapshotDirectory: (request) => transport.call("bxBackup/listSnapshotDirectory", request),
      overview: (request) => transport.call("bxBackup/overview", request),
      repoStats: (request) => transport.call("bxBackup/repoStats", request),
      restoreCancel: (request) => transport.call("bxBackup/restoreCancel", request),
      restoreList: (request) => transport.call("bxBackup/restoreList", request),
      restoreStart: (request) => transport.call("bxBackup/restoreStart", request),
      restoreStatus: (request) => transport.call("bxBackup/restoreStatus", request),
    },
    certTool: {
      completeChain: (request) => transport.call("certTool/completeChain", request),
      createItem: (request) => transport.call("certTool/createItem", request),
      deleteEntry: (request) => transport.call("certTool/deleteEntry", request),
      deleteItem: (request) => transport.call("certTool/deleteItem", request),
      getItem: (request) => transport.call("certTool/getItem", request),
      importCertificate: (request) => transport.call("certTool/importCertificate", request),
      inspect: (request) => transport.call("certTool/inspect", request),
      listItems: (request) => transport.call("certTool/listItems", request),
      previewImport: (request) => transport.call("certTool/previewImport", request),
      renew: (request) => transport.call("certTool/renew", request),
    },
    certViewer: {
      inspectFile: (request) => transport.call("certViewer/inspectFile", request),
      inspectUpload: (request) => transport.call("certViewer/inspectUpload", request),
    },
    changelog: {
      list: () => transport.call("changelog/list"),
    },
    claude: {
      ask: (request) => transport.call("claude/ask", request),
      cancel: (request) => transport.call("claude/cancel", request),
      events: (request) => transport.call("claude/events", request),
      models: () => transport.call("claude/models"),
      runs: (request) => transport.call("claude/runs", request),
      saveSettings: (request) => transport.call("claude/saveSettings", request),
      settings: () => transport.call("claude/settings"),
      stats: (request) => transport.call("claude/stats", request),
      status: () => transport.call("claude/status"),
    },
    cve: {
      coverage: (request) => transport.call("cve/coverage", request),
      createException: (request) => transport.call("cve/createException", request),
      deleteException: (request) => transport.call("cve/deleteException", request),
      detail: (request) => transport.call("cve/detail", request),
      deviceState: (request) => transport.call("cve/deviceState", request),
      instanceState: (request) => transport.call("cve/instanceState", request),
      list: (request) => transport.call("cve/list", request),
      listExceptions: () => transport.call("cve/listExceptions"),
      tree: () => transport.call("cve/tree"),
      updateException: (request) => transport.call("cve/updateException", request),
    },
    dbTunnel: {
      create: (request) => transport.call("dbTunnel/create", request),
      revoke: (request) => transport.call("dbTunnel/revoke", request),
      section: (request) => transport.call("dbTunnel/section", request),
      setAddress: (request) => transport.call("dbTunnel/setAddress", request),
    },
    deployment: {
      apply: (request) => transport.call("deployment/apply", request),
      bulkApply: (request) => transport.call("deployment/bulkApply", request),
      bulkUpdate: (request) => transport.call("deployment/bulkUpdate", request),
      bulkUpgrade: (request) => transport.call("deployment/bulkUpgrade", request),
      bulkValidate: (request) => transport.call("deployment/bulkValidate", request),
      bulkValues: (request) => transport.call("deployment/bulkValues", request),
      caddyVhostFiles: (request) => transport.call("deployment/caddyVhostFiles", request),
      certItemUsage: (request) => transport.call("deployment/certItemUsage", request),
      containers: (request) => transport.call("deployment/containers", request),
      createGlobalMatcher: (request) => transport.call("deployment/createGlobalMatcher", request),
      createInstance: (request) => transport.call("deployment/createInstance", request),
      dataUsage: (request) => transport.call("deployment/dataUsage", request),
      deleteGlobalMatcher: (request) => transport.call("deployment/deleteGlobalMatcher", request),
      deleteInstance: (request) => transport.call("deployment/deleteInstance", request),
      deleteLabel: (request) => transport.call("deployment/deleteLabel", request),
      deletePreflight: (request) => transport.call("deployment/deletePreflight", request),
      deployableRevisions: (request) => transport.call("deployment/deployableRevisions", request),
      describeTemplate: (request) => transport.call("deployment/describeTemplate", request),
      getGlobalMatcher: (request) => transport.call("deployment/getGlobalMatcher", request),
      getInstance: (request) => transport.call("deployment/getInstance", request),
      getRun: (request) => transport.call("deployment/getRun", request),
      hashEditorPassword: (request) => transport.call("deployment/hashEditorPassword", request),
      instancesWithDependencyUpdate: () => transport.call("deployment/instancesWithDependencyUpdate"),
      labels: (request) => transport.call("deployment/labels", request),
      listGlobalMatchers: () => transport.call("deployment/listGlobalMatchers"),
      listInstances: (request) => transport.call("deployment/listInstances", request),
      listRuns: (request) => transport.call("deployment/listRuns", request),
      listTemplates: () => transport.call("deployment/listTemplates"),
      parseMatcher: (request) => transport.call("deployment/parseMatcher", request),
      plan: (request) => transport.call("deployment/plan", request),
      prerequisites: (request) => transport.call("deployment/prerequisites", request),
      recentTraffic: (request) => transport.call("deployment/recentTraffic", request),
      renderMatcher: (request) => transport.call("deployment/renderMatcher", request),
      renderStructuredPreview: (request) => transport.call("deployment/renderStructuredPreview", request),
      revealSecret: (request) => transport.call("deployment/revealSecret", request),
      scanBaseInstall: (request) => transport.call("deployment/scanBaseInstall", request),
      scanComposeProject: (request) => transport.call("deployment/scanComposeProject", request),
      scanLegacyCms: (request) => transport.call("deployment/scanLegacyCms", request),
      serverTraffic: (request) => transport.call("deployment/serverTraffic", request),
      setLabel: (request) => transport.call("deployment/setLabel", request),
      setLimits: (request) => transport.call("deployment/setLimits", request),
      setTemplateSensors: (request) => transport.call("deployment/setTemplateSensors", request),
      trafficByDevice: (request) => transport.call("deployment/trafficByDevice", request),
      trafficLogs: (request) => transport.call("deployment/trafficLogs", request),
      trafficRequests: (request) => transport.call("deployment/trafficRequests", request),
      undeploy: (request) => transport.call("deployment/undeploy", request),
      unusedTemplateRevisions: () => transport.call("deployment/unusedTemplateRevisions"),
      updateGlobalMatcher: (request) => transport.call("deployment/updateGlobalMatcher", request),
      updateInstance: (request) => transport.call("deployment/updateInstance", request),
      upgradeInstance: (request) => transport.call("deployment/upgradeInstance", request),
      usage: (request) => transport.call("deployment/usage", request),
      usageOverview: (request) => transport.call("deployment/usageOverview", request),
      validate: (request) => transport.call("deployment/validate", request),
      verify: (request) => transport.call("deployment/verify", request),
    },
    device: {
      create: (request) => transport.call("device/create", request),
      delete: (request) => transport.call("device/delete", request),
      deleteLabel: (request) => transport.call("device/deleteLabel", request),
      details: (request) => transport.call("device/details", request),
      facts: (request) => transport.call("device/facts", request),
      labels: (request) => transport.call("device/labels", request),
      move: (request) => transport.call("device/move", request),
      overview: (request) => transport.call("device/overview", request),
      setLabel: (request) => transport.call("device/setLabel", request),
      setSetting: (request) => transport.call("device/setSetting", request),
      settings: (request) => transport.call("device/settings", request),
      update: (request) => transport.call("device/update", request),
    },
    dns: {
      deleteOperator: (request) => transport.call("dns/deleteOperator", request),
      operators: (request) => transport.call("dns/operators", request),
      reorderOperators: (request) => transport.call("dns/reorderOperators", request),
      resolve: (request) => transport.call("dns/resolve", request),
      saveOperator: (request) => transport.call("dns/saveOperator", request),
    },
    fileSync: {
      cancel: (request) => transport.call("fileSync/cancel", request),
      get: (request) => transport.call("fileSync/get", request),
      list: (request) => transport.call("fileSync/list", request),
      listChildren: (request) => transport.call("fileSync/listChildren", request),
      listEvents: (request) => transport.call("fileSync/listEvents", request),
      start: (request) => transport.call("fileSync/start", request),
    },
    images: {
      detail: (request) => transport.call("images/detail", request),
      list: (request) => transport.call("images/list", request),
    },
    incident: {
      ack: (request) => transport.call("incident/ack", request),
      addComment: (request) => transport.call("incident/addComment", request),
      addLink: (request) => transport.call("incident/addLink", request),
      assign: (request) => transport.call("incident/assign", request),
      close: (request) => transport.call("incident/close", request),
      create: (request) => transport.call("incident/create", request),
      deleteComment: (request) => transport.call("incident/deleteComment", request),
      deleteEscalationPolicy: (request) => transport.call("incident/deleteEscalationPolicy", request),
      deleteLink: (request) => transport.call("incident/deleteLink", request),
      edit: (request) => transport.call("incident/edit", request),
      editComment: (request) => transport.call("incident/editComment", request),
      editLink: (request) => transport.call("incident/editLink", request),
      get: (request) => transport.call("incident/get", request),
      list: (request) => transport.call("incident/list", request),
      listEscalationPolicies: () => transport.call("incident/listEscalationPolicies"),
      listGroups: () => transport.call("incident/listGroups"),
      remediate: (request) => transport.call("incident/remediate", request),
      reopen: (request) => transport.call("incident/reopen", request),
      resolveRefs: (request) => transport.call("incident/resolveRefs", request),
      saveEscalationPolicy: (request) => transport.call("incident/saveEscalationPolicy", request),
      testNotificationChannel: (request) => transport.call("incident/testNotificationChannel", request),
      tree: () => transport.call("incident/tree"),
      unack: (request) => transport.call("incident/unack", request),
      unassign: (request) => transport.call("incident/unassign", request),
    },
    infrastructure: {
      teleportVersions: () => transport.call("infrastructure/teleportVersions"),
    },
    integrity: {
      adoptBaseline: (request) => transport.call("integrity/adoptBaseline", request),
      checks: () => transport.call("integrity/checks"),
      closeFinding: (request) => transport.call("integrity/closeFinding", request),
      createException: (request) => transport.call("integrity/createException", request),
      deleteException: (request) => transport.call("integrity/deleteException", request),
      deviceState: (request) => transport.call("integrity/deviceState", request),
      exceptFindings: (request) => transport.call("integrity/exceptFindings", request),
      listExceptions: () => transport.call("integrity/listExceptions"),
      listFindings: (request) => transport.call("integrity/listFindings", request),
      peerCompare: (request) => transport.call("integrity/peerCompare", request),
      runDevice: (request) => transport.call("integrity/runDevice", request),
      tree: () => transport.call("integrity/tree"),
      updateException: (request) => transport.call("integrity/updateException", request),
    },
    mcp: {
      catalog: () => transport.call("mcp/catalog"),
    },
    metrics: {
      deploymentQuery: (request) => transport.call("metrics/deploymentQuery", request),
      deploymentSummarize: (request) => transport.call("metrics/deploymentSummarize", request),
      hostHealth: (request) => transport.call("metrics/hostHealth", request),
      monitoringStore: () => transport.call("metrics/monitoringStore"),
      query: (request) => transport.call("metrics/query", request),
      summarize: (request) => transport.call("metrics/summarize", request),
    },
    oncall: {
      assignShift: (request) => transport.call("oncall/assignShift", request),
      claimShift: (request) => transport.call("oncall/claimShift", request),
      current: () => transport.call("oncall/current"),
      deleteMembership: (request) => transport.call("oncall/deleteMembership", request),
      deleteOwnUnavailability: (request) => transport.call("oncall/deleteOwnUnavailability", request),
      deleteUnavailability: (request) => transport.call("oncall/deleteUnavailability", request),
      pool: () => transport.call("oncall/pool"),
      roster: (request) => transport.call("oncall/roster", request),
      saveDayTimes: (request) => transport.call("oncall/saveDayTimes", request),
      saveMembership: (request) => transport.call("oncall/saveMembership", request),
      saveOwnUnavailability: (request) => transport.call("oncall/saveOwnUnavailability", request),
      saveUnavailability: (request) => transport.call("oncall/saveUnavailability", request),
    },
    packages: {
      detail: (request) => transport.call("packages/detail", request),
      list: (request) => transport.call("packages/list", request),
    },
    scheduler: {
      availableJobClasses: () => transport.call("scheduler/availableJobClasses"),
      cancelJob: (request) => transport.call("scheduler/cancelJob", request),
      createUpdateJob: (request) => transport.call("scheduler/createUpdateJob", request),
      deleteJob: (request) => transport.call("scheduler/deleteJob", request),
      disableJob: (request) => transport.call("scheduler/disableJob", request),
      enableJob: (request) => transport.call("scheduler/enableJob", request),
      history: (request) => transport.call("scheduler/history", request),
      knownJob: (request) => transport.call("scheduler/knownJob", request),
      knownJobs: () => transport.call("scheduler/knownJobs"),
      run: (request) => transport.call("scheduler/run", request),
      runJob: (request) => transport.call("scheduler/runJob", request),
      runningJobs: () => transport.call("scheduler/runningJobs"),
      start: () => transport.call("scheduler/start"),
      stop: (request) => transport.call("scheduler/stop", request),
    },
    sensor: {
      certFileEntries: (request) => transport.call("sensor/certFileEntries", request),
      checkNow: (request) => transport.call("sensor/checkNow", request),
      delete: (request) => transport.call("sensor/delete", request),
      deleteReport: (request) => transport.call("sensor/deleteReport", request),
      deleteWindow: (request) => transport.call("sensor/deleteWindow", request),
      get: (request) => transport.call("sensor/get", request),
      getReport: (request) => transport.call("sensor/getReport", request),
      getWindow: (request) => transport.call("sensor/getWindow", request),
      history: (request) => transport.call("sensor/history", request),
      list: (request) => transport.call("sensor/list", request),
      outputHistory: (request) => transport.call("sensor/outputHistory", request),
      pause: (request) => transport.call("sensor/pause", request),
      previewReport: (request) => transport.call("sensor/previewReport", request),
      probeAgents: () => transport.call("sensor/probeAgents"),
      reports: () => transport.call("sensor/reports"),
      resume: (request) => transport.call("sensor/resume", request),
      save: (request) => transport.call("sensor/save", request),
      saveReport: (request) => transport.call("sensor/saveReport", request),
      saveWindow: (request) => transport.call("sensor/saveWindow", request),
      sendReport: (request) => transport.call("sensor/sendReport", request),
      tree: () => transport.call("sensor/tree"),
      windows: (request) => transport.call("sensor/windows", request),
    },
    staticSites: {
      delete: (request) => transport.call("staticSites/delete", request),
      deleteLabel: (request) => transport.call("staticSites/deleteLabel", request),
      labels: (request) => transport.call("staticSites/labels", request),
      list: () => transport.call("staticSites/list"),
      regenerateConfigs: () => transport.call("staticSites/regenerateConfigs"),
      setLabel: (request) => transport.call("staticSites/setLabel", request),
    },
    tls: {
      certificates: (request) => transport.call("tls/certificates", request),
      get: (request) => transport.call("tls/get", request),
      list: (request) => transport.call("tls/list", request),
      start: (request) => transport.call("tls/start", request),
    },
    updates: {
      deviceState: (request) => transport.call("updates/deviceState", request),
      list: (request) => transport.call("updates/list", request),
      packageChangelog: (request) => transport.call("updates/packageChangelog", request),
      runDevice: (request) => transport.call("updates/runDevice", request),
      tree: () => transport.call("updates/tree"),
    },
  };
}
